import type { StartTimeoutRange, StartTimeoutsResponse } from '@evi/shared';

/** Timeout rows describe activity, not a census of chargers in scope. */
export function startTimeoutEmptyMessage(data: StartTimeoutsResponse, range: StartTimeoutRange, chargerCount?: number): string {
  const starts = data.chargers.reduce((n, row) => n + row.starts, 0);
  const timeouts = data.chargers.reduce((n, row) => n + row.timed_out + row.late_cancel, 0);
  if (chargerCount === 0 && data.chargers.length === 0) return data.is_scoped ? 'No chargers in your scope.' : 'No chargers in this tenant.';
  if (starts === 0) return `No start timeouts in the last ${range}. No app starts recorded in this period.`;
  if (timeouts === 0) return `No start timeouts in the last ${range}.`;
  return `No site or charger over the threshold (${Math.round(data.threshold.rate * 100)}% of ${data.threshold.min_starts}+ starts) in the last ${range}.`;
}
